import { Checkbox, Text } from 'shell/components';

const CheckboxDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Checkbox</Text>

            <Checkbox />
            <Checkbox error />
            <Checkbox disabled />
            <Checkbox defaultChecked />
            <Checkbox disabled defaultChecked />

            <Checkbox label={'Label'} />
            <Checkbox error label={'Label'} />
            <Checkbox disabled label={'Label'} />
            <Checkbox defaultChecked label={'Label'} />
            <Checkbox defaultChecked disabled label={'Label'} />

            <Checkbox label={'Label'} labelPlacement={'start'} />
            <Checkbox error label={'Label'} labelPlacement={'start'} />
            <Checkbox disabled label={'Label'} labelPlacement={'start'} />
            <Checkbox defaultChecked label={'Label'} labelPlacement={'start'} />
            <Checkbox defaultChecked disabled label={'Label'} labelPlacement={'start'} />
        </>
    );
};

export default CheckboxDemo;
